<div class="content-list">
    <div class="viewer-container">
        <iframe [src]="safeEndpoint" width="100%" height="100%" style="border: none;"></iframe>
    </div>
</div>